import { IS_LOADING, ERROR } from "../../constants";

export { IS_LOADING, ERROR }

export const GET_SITES_CUSTOMER = "GET_SITES_CUSTOMER";
export const SET_SELECTED_SITE = "SET_SELECTED_SITE";